<template>
  <div class="w-110 flex flex-col gap-2 mt-auto">
    <p class="heading-xxs">Energiklass</p>
    <div class="relative flex flex-col items-center">
      <button
        v-if="energyClass"
        class="absolute top-100 w-fit h-fit pt-4 text-16 text-center underline hover:bg-blue-200 px-4 py-2"
        @click.stop="toggleEnergyModal"
      >
        Infoblad
      </button>
      <button
        v-if="energyClass"
        class="bg-blue-50 hover:bg-blue-200 h-[15rem] border border-blue-500 rounded-xs w-110"
        @click.stop="toggleEnergyDrawer"
      >
        <NuxtImg
          v-if="energyClass"
          :src="`/images/product_related/energy_${energyClass?.toLocaleLowerCase()}_label.svg`"
          alt="Energiklass för produkten"
          class="w-90 mb-[30%] mx-auto"
          loading="lazy"
          width="110"
          provider="cloudfront"
        />
      </button>
      <div
        v-else
        class="bg-blue-50 h-[15rem] border border-blue-500 rounded-xs w-110"
      >
        <div
          class="flex flex-col items-center h-full justify-between py-16 text-center"
        >
          <nuxt-icon class="text-[6rem]" name="alert-circle-blue" filled />
          <p class="heading-xxs text-[1.5rem] dark:text-text-on-highlight">
            Information saknas
          </p>
        </div>
      </div>
    </div>
  </div>
  <EnergyLabelDrawer
    v-if="energyClass"
    :show-energy-drawer-prop="showEnergyDrawer"
    :on-close="() => (showEnergyDrawer = false)"
  >
    <span>
      <LazyRoundedLoadingBox
        v-show="!energyLabelIsLoaded"
        class="mx-32"
        :message="'Laddar energietiketten för produkten'"
      />
      <NuxtImg
        v-show="energyLabelIsLoaded"
        class="w-full h-full"
        :src="`/shop/api-fe-server/energylabel/detailedlabel/${pacId}`"
        alt="Energietikett för produkten"
        @load="energyLabelLoadingComplete()"
      />
    </span>
  </EnergyLabelDrawer>
  <EnergyLabelModal
    v-if="energyClass"
    :show-energy-modal-prop="showEnergyModal"
    :on-close="() => (showEnergyModal = false)"
  >
    <embed
      class="w-full h-[70dvh]"
      :src="`/shop/api-fe-server/energylabel/datasheet/${pacId}`"
  /></EnergyLabelModal>
</template>

<script setup lang="ts">
import EnergyLabelDrawer from '~/components/pdp/energylabel/EnergyLabelDrawer.vue';
import EnergyLabelModal from '~/components/pdp/energylabel/EnergyLabelModal.vue';

const store = useMyProductPageStore();

const energyClass = computed(() =>
  store.product?.Specifications?.find(
    (spec: { Name: string; Value: string }) => spec.Name === 'Energiklass',
  ),
).value?.Value;

const pacId = store.product?.Variants[0].ProductAttributeCombinationId;

const showEnergyDrawer: Ref<boolean> = ref(false);
const showEnergyModal: Ref<boolean> = ref(false);
const energyLabelIsLoaded: Ref<boolean> = ref(false);

function energyLabelLoadingComplete() {
  energyLabelIsLoaded.value = true;
}

const toggleEnergyDrawer = () => {
  showEnergyDrawer.value = !showEnergyDrawer.value;
};

const toggleEnergyModal = () => {
  showEnergyModal.value = !showEnergyModal.value;
};
</script>
